import { isShippingCarrier } from "@shared/types/shipping";
import { detectPlatform } from "./platform";
export function isShippingPlatform(platform) {
    return isShippingCarrier(platform);
}
export function hasShippingMetadata(content) {
    return content.subtype === "shipping";
}
export function shouldRenderShippingFromLink(content) {
    if (hasShippingMetadata(content))
        return true;
    return isShippingPlatform(detectPlatform(content.url));
}
